module.exports = __webpack_public_path__ + "img/img_RealBusiness.ca1d6e33.png";